import { api } from '../../api'
import type { UserListDTO } from '@/types/admin'
import type { UserRole } from '@/types'

export interface UsersPageResponse {
  content: UserListDTO[]
  totalElements: number
  totalPages: number
  size: number
  number: number
}

/**
 * Get paginated list of users with optional filters
 */
export async function getUsers(params: {
  page?: number
  size?: number
  role?: UserRole
  restaurantId?: number
  search?: string
}): Promise<UsersPageResponse> {
  const response = await api.get<UsersPageResponse>('/api/admin/users', { params })
  return response.data
}

/**
 * Delete a user
 */
export async function deleteUser(userId: number): Promise<void> {
  await api.delete(`/api/admin/users/${userId}`)
}
